module.exports = __webpack_public_path__ + "static/soon-8b8afb9cf4c3c92598df76c470237758.png";